module.exports = __webpack_public_path__ + "img/icono1.3622332c.svg";